import React from "react";
import "./TableRecord.css"; // Import the CSS file

const TableRecord = () => {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="overflow-x-auto">
        <table className="w-100 border-collapse border border-gray-400">
          <thead>
            <tr className="bg-orange-500 text-white">
              <th className=" border-black-400  table-header">Quarter</th>
              <th className="border border-black-400 table-header">
                Initial Circulating Supply
              </th>
              <th className="border border-black-400 table-header">
                Marketing/Community Unlocks
              </th>
              <th className="border border-black-400 table-header">
                Developer Unlock
              </th>
              <th className="border border-black-400 table-header">
                Total Circulating Supply
              </th>
            </tr>
          </thead>
          <tbody>
            {[
              {
                quarter: "Q1 (TGE)",
                initialSupply: "700 M",
                marketingUnlocks: "0.00",
                developerUnlock: "0.00",
                totalSupply: "700 M",
                bgColor: "bg-purple-700",
              },
              {
                quarter: "Q2",
                initialSupply: "700 M",
                marketingUnlocks: "250 M",
                developerUnlock: "0.00",
                totalSupply: "725 M",
                bgColor: "bg-purple-100",
              },
              {
                quarter: "Q3",
                initialSupply: "700 M",
                marketingUnlocks: "500 M",
                developerUnlock: "0.00",
                totalSupply: "750 M",
                bgColor: "bg-purple-100",
              },
              {
                quarter: "Q4",
                initialSupply: "700 M",
                marketingUnlocks: "750 M",
                developerUnlock: "0.00",
                totalSupply: "775 M",
                bgColor: "bg-purple-100",
              },
              {
                quarter: "Q5",
                initialSupply: "700 M",
                marketingUnlocks: "100 M",
                developerUnlock: "7.98 M",
                totalSupply: "807.98 M",
                bgColor: "bg-purple-100",
              },
              {
                quarter: "Q6",
                initialSupply: "700 M",
                marketingUnlocks: "125 M",
                developerUnlock: "159.6 M",
                totalSupply: "840.96 M",
                bgColor: "bg-purple-100",
              },
              {
                quarter: "Q7",
                initialSupply: "700 M",
                marketingUnlocks: "140 M",
                developerUnlock: "239.4 M",
                totalSupply: "863.94 M",
                bgColor: "bg-purple-100",
              },
              {
                quarter: "Q8",
                initialSupply: "700 M",
                marketingUnlocks: "140 M",
                developerUnlock: "879.4 M",
                totalSupply: "927.94 M",
                bgColor: "bg-purple-100",
              },
              {
                quarter: "Q9",
                initialSupply: "700 M",
                marketingUnlocks: "140 M",
                developerUnlock: "959.2 M",
                totalSupply: "935.92 M",
                bgColor: "bg-purple-100",
              },
              {
                quarter: "Q10",
                initialSupply: "700 M",
                marketingUnlocks: "140 M",
                developerUnlock: "160 M",
                totalSupply: "1 B",
                bgColor: "bg-purple-100",
              },
            ].map((row, index) => (
              <tr key={index} className={`${row.bgColor} text-black `}>
                <td className="table-border px-4 py-2 table-colums">{row.quarter}</td>
                <td className="table-border px-4 py-2 table-colums">{row.initialSupply}</td>
                <td className="table-border px-4 py-2 table-colums">
                  {row.marketingUnlocks}
                </td>
                <td className="table-border px-4 py-2 table-colums">
                  {row.developerUnlock}
                </td>
                <td className="table-border px-4 py-2 table-colums">{row.totalSupply}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableRecord;
